import { PageBreadcrumb } from 'framework/components/breadcrumbs/PageBreadcrumb';
import { PageBreadcrumbDivider } from 'framework/components/breadcrumbs/PageBreadcrumbDivider';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { FinancialsPageBreadcrumbTitle } from '../FinancialsPageBreadcrumbTitle';
import { SalesRoute } from '../routes';

export const SalesPageBreadcrumb = () => {
	const strings = useLocalization();

	return (
		<React.Fragment>
			<FinancialsPageBreadcrumbTitle />
			<PageBreadcrumbDivider />
			<PageBreadcrumb
				text={strings.sales}
				route={SalesRoute}
			/>
		</React.Fragment>
	);
};
